var map = {
	"./ar/contact.json": [
		7858,
		7858
	],
	"./ar/demosticTourism.json": [
		8359,
		8359
	],
	"./ar/elhag&umrah.json": [
		2050,
		2050
	],
	"./ar/flighTicket.json": [
		68,
		68
	],
	"./ar/home.json": [
		6952,
		6952
	],
	"./ar/hotelBooking.json": [
		3818,
		3818
	],
	"./ar/internationalTourism.json": [
		8612,
		8612
	],
	"./en/contact.json": [
		1978,
		1978
	],
	"./en/demosticTourism.json": [
		5360,
		5360
	],
	"./en/elhag&umrah.json": [
		4871,
		4871
	],
	"./en/flighTicket.json": [
		9821,
		9821
	],
	"./en/home.json": [
		6325,
		6325
	],
	"./en/hotelBooking.json": [
		6895,
		6895
	],
	"./en/internationalTourism.json": [
		3442,
		3442
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 7148;
module.exports = webpackAsyncContext;